import React, { useEffect, useState } from "react";
import { Backdrop, Checkbox, Fade, FormControlLabel, makeStyles, Modal, Typography } from "@material-ui/core";
import { Mention, MentionsInput } from "react-mentions";
import { getAllTeamUsers } from "../../../../api/contactApi";
import defaultStyle from "./defaultStyle";
import { addNote, updateTimelineNote } from "../../../addContact/contactApi";

const modalStyles = makeStyles((theme) => ({
  wrapperMain: {
    marginLeft: "10px",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    width: (props) => props.modalWidth,
    height: '390px !important',
    display: "flex",
    flexDirection: "column",
    backgroundColor: theme.palette.background.paper,
    borderRadius: "8px",
    boxShadow: theme.shadows[5],
    '&:focus-visible': {
      outline: "none !important",
    },
  },
  modalHeader: {
    padding: "12px",
    color: "#fff",
    backgroundColor: "#fff !important",
    borderTopRightRadius: "8px",
    borderTopLeftRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "start !important",
  },
  modalBody: {
    flexGrow: 1, 
    backgroundColor: "#fff !important",
  },

  modalFooter: {
    borderEndEndRadius: "8px",
    borderEndStartRadius: "8px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "8px",
    height: "80px",
    background: "#fff !important",
  },
  checkBoxStyle: {
    color: "#0E1B3D",
    fontSize: "16px !important",
    fontWeight: "600",
  },
  cancelButton: {
    color: "var(--accent-color) !important",
  },
  typographyStyle: {
    height: "unset !important",
    color: "#133159",
    fontWeight: 500,
    fontSize: "15px",
    marginBottom: "20px",
    textAlign: "center",
  },
  button: {
    padding: "8px 16px",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
  },
  closeButton: {
    backgroundColor: "#fff",
    color: "#000",
    border: "1px solid #a5a5a5",
    "&:focus, &:hover": {
      backgroundColor: "#f3f4f6",
      transform: "translateY(-1px)",
      border: "1px solid #a5a5a5",
    },
  },
  confirmButton: {
    backgroundColor: "#3e50f7",
    padding: "8px 24px",
    color: "#fff",
    border: "1px solid #3e50f7",
    "&:focus, &:hover": {
      border: "1px solid #3e50f7",
      backgroundColor: "#3e50f7",
      transform: "translateY(-1px)",
    },
    "&:disabled": {
    backgroundColor: "rgba(0, 0, 0, 0.12)",
    color: "rgba(0, 0, 0, 0.26)",
    border: "1px solid rgba(0, 0, 0, 0.12)",
    cursor: "default",
    transform: "none",
  },
  },
}));
const mentionStyle = {
  backgroundColor: "#cee4e5",
};
const AddNoteModal = ({ modalWidth = 650, open, onClose, globalNoteData="" }) => {
  const [note, setNote] = useState("");
  const [allTeamUser, setAllTeamUser] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isStickyNote, setIsStickyNote] = useState(false);
  const classes = modalStyles({ modalWidth });
  const headerIconSrc = `${process.env.REACT_APP_CDN_LINK}assets/images/releases/1.0.0/notepad_9305648.png`;
  const [isSubmitting, setIsSubmitting] = useState(false);  
  const [error, setError] = useState(null);
  useEffect(() => {
    loadTeamUserList();
  }, []); 

  useEffect(() => {
   setNote(globalNoteData?.editData?.message || '');
   if(globalNoteData?.stickyNote && globalNoteData?.stickyNote.timeline_id === globalNoteData?.editData?.id){
    setIsStickyNote(true);
   }
  }, [globalNoteData?.editData]);

  const isUnchanged =
  globalNoteData?.editData &&
  note === globalNoteData.editData.message &&
  isStickyNote === (globalNoteData?.stickyNote?.timeline_id === globalNoteData?.editData?.id);

  const changeNote = (event) => {
    setError(null);
    setNote(event.target.value || "");
  };
  const handleSubmit = () => {

   if(globalNoteData?.editData){
    handleUpdateTimelineNote();
   } else {
    handleAddNote();
   }
  };
  const loadTeamUserList = () => {
    const teamUsers = sessionStorage.getItem("allTeamUsers");
     if (teamUsers) {
      try {
        const parsedUsers = JSON.parse(teamUsers);
        setAllTeamUser(parsedUsers);
        return;
      } catch (error) {
        console.error("Failed to parse team users from sessionStorage:", error);
        sessionStorage.removeItem("allTeamUsers");
        fetchTeamUsers();
       }
    } else {
      fetchTeamUsers();
    }
  };
  const fetchTeamUsers = async () => {
    try {
      setLoading(true);
      const res = await getAllTeamUsers({});
      const rawUsers = res?.data?.users;
      if (Array.isArray(rawUsers)) {
        const users = rawUsers.map(({ value, label }) => ({
          id: value,
          display: label,
        }));
        setAllTeamUser(users);
        sessionStorage.setItem("allTeamUsers", JSON.stringify(users));
      }
    } catch (err) {
      console.error("Failed to fetch team users from API:", err);
    } finally {
      setLoading(false);
    }
  };
  const handleAddNote = async () => {
    if(note.trim() === ""){
      setError("Note is required");
      return;
    }
    setIsSubmitting(true);
    try {
      const res = await addNote({
        note: note,
        contact_id: globalNoteData?.payload?.contact_id,
        origin: globalNoteData?.payload?.origin,
        use_as_sticky_note: isStickyNote ? "TRUE" : "FALSE",
      });
  
      if (res.data.status === 'success') {
        if (globalNoteData?.callback) {
          globalNoteData.callback();
        }
        window.showNotification("SUCCESS", "Add Note Successfully");
        onClose();
      }
    } catch (error) {
      console.error("Error adding note:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleUpdateTimelineNote = async () => {
    setIsSubmitting(true);
    try {
      const res = await updateTimelineNote({
        id: globalNoteData?.editData?.id,
        note,
        contact_id: globalNoteData?.editData?.contact_id,
        use_as_sticky_note: isStickyNote ? "TRUE" : "FALSE",
      });
      if (res.data.status === 'success') {
        if (globalNoteData?.callback) {
          globalNoteData.callback(note);
        }
        window.showNotification("SUCCESS", "Note Updated Successfully");
        onClose();
      }
    } catch (error) {
      console.error("Error updating timeline note:", error);
    } finally {
      setIsSubmitting(false);
    }
  };
  
  
  return (
    <div className={classes.wrapperMain}>
      <Modal
        open={open}
        onClose={onClose}
        className={classes.modal}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 200,
        }}
      >
        <Fade in={open}>
          <div className={classes.paper}>
            <div className={classes.modalHeader}>
              <div style={{ width: "50px", height: "50px" }}>
                {headerIconSrc && (
                  <img
                    src={headerIconSrc}
                    alt='logo'
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                )}
              </div>

              <div style={{ marginLeft: "16px" }}>
                <Typography
                  style={{
                    height: "unset !important",
                    color: "#133159",
                    fontWeight: 600,
                  }}
                  variant='h5'
                >
                 {globalNoteData?.editData ? "Edit Note" : "New Note"}
                </Typography>
              </div>
            </div>

            <div className={classes.modalBody}>
              <div className='modal-content p-0'>
                <div className='chat__bottom_wrapper update'>
                  <div className='tiny-mce'>
                    <MentionsInput
                      cols={30}
                      rows={5}
                      className='control-overflow mentionClass'
                      value={note}
                      onChange={changeNote}
                      style={defaultStyle}
                      markup='@[__display__](__id__) '
                      placeholder={" Add notes and mentions (@username)"}
                    >
                      <Mention
                        type='user'
                        trigger='@'
                        data={allTeamUser}
                        renderSuggestion={(suggestion, search, highlightedDisplay) => (
                          <div className='user'>{highlightedDisplay}</div>
                        )}
                        displayTransform={(id, display) => `@${display}`}
                        style={mentionStyle}
                      />
                    </MentionsInput>
                    {
                      error && <div style={{ color: "red" , marginTop: "6px"}}>{error}</div>
                    }
                  </div>
                </div>
              </div>
            </div>
            <div className={classes.modalFooter}>
              <div style={{ marginLeft: "20px" }}>
                <div>
                  <FormControlLabel
                    control={
                      <Checkbox
                        className={classes.cancelButton}
                        size={"small"}
                        checked={isStickyNote}
                        onChange={() => setIsStickyNote(!isStickyNote)}
                      />
                    }
                    className={classes.checkBoxStyle}
                    label='Make it a sticky note'
                  />
                </div>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", gap: "20px", marginRight: "16px" }}>
                <button
                  onClick={handleSubmit}
                  disableElevation
                  disabled={isSubmitting || isUnchanged}
                  className={`${classes.button} ${classes.confirmButton}`}
                >
                  { isSubmitting ? "Saving..." : "Save"}
                </button>
              </div>
            </div>
          </div>
        </Fade>
      </Modal>
    </div>
  );
};

export default AddNoteModal;
